import type { OrganizationMembership, User } from '@/store/user.ts'

type MembershipWithIri = OrganizationMembership & { '@id'?: string }

/**
 * The membership the server treats as active, read from the user itself rather than from
 * the store: right after an organization switch the store can still hold the previous one.
 * Falls back to the first membership, as `loginUser` and `useSyncUser` do.
 */
export function activeMembership(
  user: User | null | undefined,
): OrganizationMembership | undefined {
  const memberships = user?.organizationMemberships
  if (!memberships?.length) return undefined
  return (
    (memberships as MembershipWithIri[]).find(m => m?.['@id'] === user?.activeMembership) ??
    memberships[0]
  )
}
